export default {
	"Timezone": "Fuseau horaire",
	"Sample Record": "Échantillons",
	"Sync Normal": "Sync Normal",
	"SOS Phone": "Téléphone SOS",
	"Offline Timer": "Temporizador offline",
	"Fall Detection": "Détection de chute",
	"Reference Systolic": "Référence Systolique",
	"Reference Diastolic": "Référence Diastolique",
	"Heart Rate Min": "Fréquence cardiaque min",
	"Heart Rate Max": "Fréquence cardiaque max",
}


// WEBPACK FOOTER //
// ./src/i18n/configurations/configurations_fr.js